import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PlusIcon from "../components/common/Icons/PlusIcon";
import PageHeader from "../components/common/PageHeader";
import SkillSettingsTable from "../components/Settings/Skills/SkillSettingsTable";

const SkillSettings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container>
      <PageHeader
        pageTitle="Yetenek Listesi"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Yetenek"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <SkillSettingsTable />
    </Container>
  );
};

export default SkillSettings;
